<template>
    <div @click="handleImageNodeClick" :class="{'clickable': !!handleImageClick}">
        <div v-if="editMode" class='header row between'>
            <span class='image-name'></span>
            <button @click="() => handleDeleteImageClick(img)">Delete</button> 
        </div>
        <span
            class='img-container'
            :style="{'max-height': editMode ? '100%' : '280px'}"
        >
            <img 
                :src="img.thumb || img.url"
                class='splash-image'
                alt="website image"
                v-if="img.thumb || img.url"
                :style="{'border-radius': editMode ? '0' : '5px 5px 0px 0px'}"
            />
        </span>
        <span v-if="editMode" class='cat-label'>Change category</span>
        <span class='center p-10'>
            <select 
                @change="handleCatChange"
                name="filter"
                :value="img.category"
                v-if="editMode"
            >
                <option value=''> No category </option>
                <option v-for="(cat, index) in categories" :key="'cat-' + index" :value="cat">
                    {{ cat }}
                </option>
            </select>
            <div v-else class='row between edit-container c-v'>
                <span>{{ img.category || 'No category' }}</span>
                <button @click="editModeToggle" v-if="saveImageData">
                    Edit
                </button>
            </div>
        </span>
        <ul class='l-reset' v-if="editMode">
            <li>
                <span>Featured</span>
                <toggle 
                    :value="img.featured" 
                    :name="'feat-' + index" 
                    :onChange="() => handleToggleChange('featured')" 
                />
            </li>
            <li>
                <span>Show in gallery</span>
                <toggle 
                :value="img.showInGallery" 
                :name="'showGal-' + index" 
                :onChange="() => handleToggleChange('showInGallery')"
                />
            </li>
        </ul>
        <div class='container row between' v-else>
            <span v-if="img.showInGallery" class='green'>Shown in gallery</span>
            <span v-else class='red'>Not shown in gallery</span>

            <span v-if="img.featured" class='green'>Is Featured</span>
            <span v-else class='red'>Not Featured</span>
        </div>
        <span v-if="editMode" class='cat-label'>Image title</span>
        <textarea 
            v-if="editMode"
            class='edit-image-title-field'
            @input="updateTextValue"
            :value="img.title"
        />
        <p v-else class='container pt-10 pb-10 gray'>{{ img.title }}</p>

        <div class='container'>
            <p class='mt-10' v-if="editMode">Tags</p>
            <tag-list
                :list="img.tags"
                :readMode="!editMode"
                :onUpdateTag="updateTags"
            />
        </div>

        <div v-if="editMode" class='bottom-button-group'>
            <button @click="editModeToggle" class='toggle-close btn red'>
                Stop Editting
            </button>
            <button 
                @click="handleSaveClick"
                class='toggle-close btn green'
                v-if="hasChanges"
            >
                Save
            </button>
            <span v-else />
        </div>
        <copy-card
            :slimCard="true"
            :text="img.url"
        />
    </div>
</template>

<script>
import CopyCard from '@/myComponents/CopyCard.vue'
import TagList from './TagList'
import Toggle from './Toggle'
export default {
    components: { Toggle, CopyCard, TagList },
    props: ['imgData', 'categories', 'index', 'saveImageData', 'handleDeleteImageClick', 'handleImageClick'],
    data: () => ({
        editMode: false,
        hasChanges: false,
        img: {}
    }),
    methods: {
        handleImageNodeClick () {
            this.handleImageClick && this.handleImageClick(this.imgData)
        },
        updateTags (action, tag) {
            if (!this.hasChanges) this.hasChanges = true
            if (action === 'add') {
                this.img.tags = [...this.img.tags, tag]
            } else {
                this.img.tags = this.img.tags.filter(t => t !== tag)
            }
        },
        editModeToggle () { 
            this.editMode = !this.editMode
        },
        handleToggleChange (property) {
            if (!this.hasChanges) this.hasChanges = true
            this.img[property] = !this.img[property]
        },
        handleCatChange (e) {
            if (!this.hasChanges) this.hasChanges = true
            this.img.category = e.target.value
        },
        updateTextValue (e) {
            if (!this.hasChanges) this.hasChanges = true
            this.img.title = e.target.value
        },
        handleSaveClick () {
            this.editMode = false
            this.hasChange = false
            this.saveImageData(this.img)
        }
    },
    mounted: function () {
        this.img = {...this.imgData}
    }
}
</script>

<style scoped lang='scss'>
@import '../styles/colors.scss';
.img-container{
    display: block;
    overflow: hidden;
}
.clickable {
    cursor: pointer;
    &:hover {
        box-shadow: 0 0 0 1px $lightBlue;
    }
}
</style>